function findLastIndex<T>(
  array: T[],
  predicate: (value: T, index: number, obj: T[]) => boolean
): number {
  if (typeof Array.prototype.findLastIndex === 'function') {
    return array.findLastIndex(predicate)
  }
  for (let i = array.length - 1; i >= 0; i--) {
    if (predicate(array[i], i, array)) {
      return i
    }
  }
  return -1
}

export default findLastIndex
